import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Modal, Loader } from '../../../common/components';
import { switchBroker, switchOrganisation, getOrganisations } from '../redux/authActions';
import { closeModal } from '../../../common/components/Modal/ModalRedux';
import { FullRow } from '../../layout/components';
import { push } from 'react-router-redux';


const FORM_NAME = 'organisation-settings';

const SelectTitle = ({ name, id, onSelect }) => {
  const select = () => {
    return onSelect(id);
  };
  return (
    <h3
      key={id}
      className="organisation-selection"
      onClick={select}
    >
      {name}
    </h3>
  );
};

const Loading = ({ isSwitchingOrganisation, isRetrievingOrganisations }) => {
  if (isSwitchingOrganisation) {
    return (<div>
      Switching...
      <Loader noShadow/>
    </div>);
  }
  if (isRetrievingOrganisations) {
    return (<div>
      Retrieving Organisations...
      <Loader noShadow/>
    </div>);
  }
  return null;
};


const Organisations = ({
  title,
  onSwitch,
  organisations,
}) => {
  if (!organisations || !organisations.length) {
    return null;
  }
  return (
    <>
      <FullRow>
        <h4 className="organisation-selection-title">{title}</h4>

      </FullRow>
      <FullRow>
        {organisations.map((organisation) => {
          return (
            <SelectTitle
              key={organisation.id}
              id={organisation.id}
              name={organisation.name}
              onSelect={onSwitch}
            />
          );
        })}
        <div className="hr"/>

      </FullRow>
    </>
  );
};

const OrganisationSettings = ({
  onSwitchOrganisation,
  onSwitchBroker,
  onGetOrganisations,
  onGoTo,
  onCloseModal,
}) => {


  const [organisationList, setOrganisationList] = useState(false);
  const [isRetrievingOrganisations, setIsRetrievingOrganisations] = useState(false);

  const { isSwitchingOrganisation } = useSelector((state) => state.auth);

  const switchToOrganisation = (organisationId) => {
    return Promise.resolve(onSwitchOrganisation(organisationId)).then(() => {
      onGoTo('/dashboard');
      onCloseModal(FORM_NAME);
    });
  };

  const switchToBroker = (brokerId) => {
    return Promise.resolve(onSwitchBroker(brokerId)).then(() => {
      onGoTo('/dashboard');
      onCloseModal(FORM_NAME);
    });
  };

  const getOrganisations = () => {
    if (!organisationList && !isRetrievingOrganisations) {
      setIsRetrievingOrganisations(true);
      return Promise.resolve(onGetOrganisations()).then((resp) => {
        setOrganisationList(resp);
      }).finally(() => {
        setIsRetrievingOrganisations(false);
      });
    }
  };

  return (
    <Modal
      name={FORM_NAME}
      backdropClassName="extra-dark"
      title="Organisation Settings"
      closeButton={true}
      enforceFocus={true}
      onShow={getOrganisations}
    >
      <div>
        <Loading
          isRetrievingOrganisations={isRetrievingOrganisations}
          isSwitchingOrganisation={isSwitchingOrganisation}
        />
        <Organisations
          organisations={organisationList.organisations}
          title={'Organisations'}
          onSwitch={switchToOrganisation}
        />
        <Organisations
          organisations={organisationList.brokers}
          title={'Brokers'}
          onSwitch={switchToBroker}
        />
      </div>

    </Modal>
  );
};

export default connect(
  null, {
    onSwitchOrganisation: switchOrganisation,
    onGetOrganisations: getOrganisations,
    onSwitchBroker: switchBroker,
    onGoTo: push,
    onCloseModal: closeModal,
  },
)(OrganisationSettings);

